<div class="documents-dialog" *ngIf="active">
  <div class="documents-dialog__content">
    <button class="documents-dialog__content__close" (click)="closeDialog()">
      <span class="material-icons">close</span>Close
    </button>
    <h2>{{ modalHeaderTitle }}</h2>
    <ng-container>
      <div class="">
        <div class="mb-10">{{ modalBody }}</div>
        <br />
        <br />
        <div class="panelfields mt-30">
          <button
            *ngIf="dashboard && siteVisitRequired"
            type="submit"
            class="btn btn-site-visit w-25"
            [routerLink]="['/', 'project-overview', projectId]"
            (click)="closeDialog()"
          >
            Schedule Site Visit
          </button>
          <button
            type="submit"
            class="btn btn-primary w-25"
            routerLink="/active"
            routerLinkActive="router-link-active"
            (click)="closeDialog()"
          >
            View Active Projects
          </button>
          <button
            type="submit"
            class="btn btn-default w-25"
            (click)="closeDialog()"
          >
            Back
          </button>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="documents-dialog__background" (click)="closeDialog()"></div>
</div>
